import { Box, IconButton, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useNavigate } from 'react-router-dom';
import { getAllInstallerData, getInstallerPayment } from '../../../redux/slice/installerpayment.slice';

const InstallerPayment = () => {
    const theme = useTheme();
    const [selectedInstaller, setSelectedInstaller] = useState([]);
    const [selectedElectrician, setSelectedElectrician] = useState([]);
    // const [selectedTechnician, setSelectedTechnician] = useState([]);
    const isMobile = useMediaQuery('(max-width:500px)');
    const assignInstaller = useSelector(state => state.installerpayment.assignInstaller);
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getInstallerPayment())
        dispatch(getAllInstallerData())
    }, [])

    console.log(assignInstaller, "dssddsdsdd");


    useEffect(() => {
        const dataToSubmit = assignInstaller?.flatMap(v =>
            v.fabdata?.filter(fab => fab.requestStatus === "Approved" || fab.requestStatus === "Complete")
        );
        setSelectedInstaller(dataToSubmit);
    }, [assignInstaller])

    useEffect(() => {
        const dataToSubmit = assignInstaller?.flatMap(v =>
            v.eledata?.filter(ele => ele.requestStatus === "Approved" || ele.requestStatus === "Complete")
        );
        setSelectedElectrician(dataToSubmit);

        console.log("dataToSubmit", dataToSubmit, assignInstaller);

    }, [assignInstaller])

    // useEffect(() => {
    //     const dataToSubmit = assignInstaller?.flatMap(v =>
    //         v.techdata?.filter(tech => tech.requestStatus === "Approved"|| tech.requestStatus === "Complete")
    //     );
    //     setSelectedTechnician(dataToSubmit);
    // }, [assignInstaller])

    const [selectedYear, setSelectedYear] = useState('Select Year');
    const [selectedMonth, setSelectedMonth] = useState('Select Month');

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const aggregatedInstaller = useMemo(() => {
        return selectedInstaller?.reduce((acc, item) => {
            // Process eledata array
            // item.forEach(el => {
            const billNo = item.billNo || 'no-bill'; // Use 'no-bill' for items without billNo
            if (!acc[billNo]) {
                acc[billNo] = [];
            }
            // Create a new object with just the relevant data for this bill
            acc[billNo].push({
                _id: item._id,
                ...item
            });
            // });
            return acc;
        }, {});
    }, [selectedInstaller, assignInstaller, selectedYear, selectedMonth]);

    // const aggregatedInstaller = useMemo(() => {
    //     const grouped = {};
    //     const currentDate = new Date();

    //     selectedInstaller?.forEach(installer => {
    //         const commissionDate = new Date(installer.PaymentCreatedAt);
    //         if (commissionDate <= currentDate) {
    //             const year = commissionDate.getFullYear();
    //             const month = commissionDate.getMonth();
    //             const periodKey = `${year}-${month}`;
    //             const installerName = assignInstaller?.find(u => u._id === installer.assignId)?.Fabricator;

    //             if ((selectedYear === 'Select Year' || selectedYear == year) &&
    //                 (selectedMonth === 'Select Month' || selectedMonth === new Date(0, month).toLocaleString('default', { month: 'long' }))) {
    //                 if (installer.submitDate) {
    //                     const submitKey = `${periodKey}-submitted-${new Date(installer.submitDate).toLocaleDateString('en-GB')}-${installerName}`;
    //                     if (!grouped[submitKey]) {
    //                         const startDate = new Date(year, month, 1);
    //                         const endDate = new Date(year, month + 1, 0);
    //                         grouped[submitKey] = {
    //                             startDate,
    //                             endDate,
    //                             formattedStartDate: startDate.toLocaleDateString('en-GB'),
    //                             formattedEndDate: endDate.toLocaleDateString('en-GB'),
    //                             installers: [],
    //                             submitDate: installer.submitDate,
    //                         };
    //                     }
    //                     grouped[submitKey].installers.push({
    //                         installerName: installerName,
    //                         amount: Number(installer.TotalAmount),
    //                     });
    //                 } else {
    //                     if (!grouped[periodKey]) {
    //                         const startDate = new Date(year, month, 1);
    //                         const endDate = new Date(year, month + 1, 0);
    //                         grouped[periodKey] = {
    //                             startDate,
    //                             endDate,
    //                             formattedStartDate: startDate.toLocaleDateString('en-GB'),
    //                             formattedEndDate: endDate.toLocaleDateString('en-GB'),
    //                             installers: [],
    //                         };
    //                     }
    //                     grouped[periodKey].installers.push({
    //                         installerName: installerName,
    //                         amount: Number(installer.TotalAmount),
    //                     });
    //                 }
    //             }
    //         }
    //     });

    //     return Object.entries(grouped).map(([key, value]) => ({
    //         periodKey: key,
    //         ...value,
    //         installers: value.installers.reduce((acc, { installerName, amount }) => {
    //             const existingInstaller = acc?.find(i => i.installerName === installerName);
    //             if (existingInstaller) {
    //                 existingInstaller.amount += amount;
    //             } else {
    //                 acc.push({ installerName, amount });
    //             }
    //             return acc;
    //         }, []),
    //     }));
    // }, [selectedInstaller, assignInstaller, selectedYear, selectedMonth]);

    console.log("selectedElectricianselectedElectrician", selectedElectrician, aggregatedInstaller);

    const electricianAggregatedInstaller = useMemo(() => {
        return selectedElectrician?.reduce((acc, item) => {
            // Process eledata array
            // item.forEach(el => {
            const billNo = item.billNo || 'no-bill'; // Use 'no-bill' for items without billNo
            if (!acc[billNo]) {
                acc[billNo] = [];
            }
            // Create a new object with just the relevant data for this bill
            acc[billNo].push({
                _id: item._id,
                ...item
            });
            // });
            return acc;
        }, {});

    }, [selectedElectrician, assignInstaller, selectedYear, selectedMonth]);

    console.log("selectedElectrician", electricianAggregatedInstaller, selectedElectrician);



    
    const navigate = useNavigate()
    const allInstallerpayment = useSelector(state => state.installerpayment.InstallerPayment);
    const handleEdit = (v, billNo, electricians, type) => {
        console.log("v, billNo, electricians, type", v, billNo, electricians, type);
        

        navigate('/admin/add-installer', { state: { v, billNo, electricians, type } })
    }

    console.log("aggregatedInstalleraggregatedInstaller", aggregatedInstaller, electricianAggregatedInstaller, assignInstaller)

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>

            <Header
                title="INSTALLER PAYMENT"
                subtitle="Manage Your Installer Payment Here"
            />
            <Select
                value={selectedMonth}
                onChange={handleMonthChange}
                displayEmpty
                sx={{
                    minWidth: '100%',
                    [theme.breakpoints.up('sm')]: {
                        minWidth: '200px',
                    },
                    [theme.breakpoints.down('sm')]: {
                        minWidth: '100%',
                    },
                    marginBottom: '20px', marginRight: '20px',
                    '& .MuiSelect-select': {
                        padding: '8px',
                        border: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                        borderWidth: '2px',
                    },
                }}
            >
                <MenuItem value="Select Month">Select Month</MenuItem>
                {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((month, index) => (
                    <MenuItem key={index} value={month}>{month}</MenuItem>
                ))}
            </Select>

            <Select
                value={selectedYear}
                onChange={handleYearChange}
                displayEmpty
                sx={{
                    minWidth: '100%',
                    [theme.breakpoints.up('sm')]: {
                        minWidth: '200px',
                    },
                    [theme.breakpoints.down('sm')]: {
                        minWidth: '100%',
                    },
                    marginBottom: '20px',
                    '& .MuiSelect-select': {
                        padding: '8px',
                        border: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                        borderWidth: '2px',
                    },
                }}
            >
                <MenuItem value="Select Year">Select Year</MenuItem>
                {Array.from({ length: 31 }, (_, index) => 2020 + index).map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
            </Select>


            <Typography variant="h4" fontWeight="600">Fabricator Installer</Typography>
            {aggregatedInstaller ? (
                <>
                    <TableContainer sx={{ marginTop: '20px' }}>
                        <Table>
                            <TableHead sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#3e4396' : '#a4a9fc' }}>
                                <TableRow>
                                    <TableCell style={{ width: '100px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>SR No.</TableCell>
                                    <TableCell style={{ width: '320px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Invoice No</TableCell>
                                    <TableCell style={{ width: '250px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Date of Period</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Fabricator Name</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Given Payment</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Payment Date</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Status</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0' }}>
                                {
                                    Object.entries(aggregatedInstaller)?.map(([billNo, fabricator], index1) => {
                                        // console.log("dddddddss", billNo, fabricator)
                                        let totalPayment = 0;
                                        let installerName;
                                        let InstallerPay;
                                        let invoiceNo;
                                        let InstallerpayTotal;
                                        let date;
                                        let givenPayment = 0;

                                        const latestDate = fabricator
                                            ?.map(e => new Date(e?.paymentDate))
                                            .filter(date => !isNaN(date)) // remove invalid dates
                                            .sort((a, b) => b - a)[0]; // descending order

                                        const formattedLatestDate = latestDate?.toLocaleDateString();

                                        fabricator?.map((v, index2) => {
                                            installerName = assignInstaller?.find(u => u._id === v.assignId)?.Fabricator;

                                            InstallerPay = allInstallerpayment?.filter(d => d?.userId == installerName)
                                            // const endDateForEdit = `${periodData.formattedStartDate} - ${periodData.periodKey.split('-')[3]}`
                                            // const InstallerDate = InstallerPay?.find(d => d.monthPeriod == endDateForEdit)
                                            InstallerpayTotal = InstallerPay?.fileDetails?.reduce((total, item) => total + (item.PaymentTotal || 0), 0) || 0
                                            invoiceNo = `Fabricator/${assignInstaller?.find(a => a.Fabricator == installerName)?.fabricatorData?.[0]?.name}/${new Date(v?.submitDate)?.toLocaleDateString()}/${billNo}`;
                                            totalPayment = totalPayment + parseFloat(v.TotalAmount)
                                            date = new Date(v?.submitDate)?.toLocaleDateString()

                                            console.log("444444", v, installerName, InstallerPay, index2 + 1, invoiceNo, totalPayment, InstallerpayTotal)

                                            if (v?.paymentAmount) {
                                                givenPayment = givenPayment + parseFloat(v?.paymentAmount + v?.tds);
                                            }
                                        });



                                        return (
                                            <TableRow key={`${index1}`}>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {index1 + 1}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {invoiceNo}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {date}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {assignInstaller?.find(a => a.Fabricator == installerName)?.fabricatorData?.[0]?.name}
                                                    {/* {assignInstaller?.find(a => a.Electrician == v.installerName)?.electricianData?.[0]?.name === "kishan patel" ? console.log("kishan patel	kishan pate", periodData) : ''} */}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{totalPayment % 1 === 0 ? totalPayment.toString() : totalPayment.toFixed(2)}</TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {givenPayment}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {
                                                        formattedLatestDate
                                                    }
                                                </TableCell>

                                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                    {givenPayment >= totalPayment ? 'Complete' : 'Pending'}
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton aria-label="edit" onClick={() => handleEdit({ installerName, amount: totalPayment, invoiceNo, billNo }, billNo, fabricator, 'fabricator')}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>

            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        No Results Found.
                    </Typography>
                </Box>
            )}

            <Typography variant="h4" fontWeight="600" sx={{ marginTop: '20px' }}>Electrician Installer</Typography>
            {electricianAggregatedInstaller ? (
                <>
                    <TableContainer sx={{ marginTop: '20px' }}>
                        <Table>
                            <TableHead sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#3e4396' : '#a4a9fc' }}>
                                <TableRow>
                                    <TableCell style={{ width: '100px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>SR No.</TableCell>
                                    <TableCell style={{ width: '320px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Invoice No</TableCell>
                                    <TableCell style={{ width: '250px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Date</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Electrician Name</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Given Payment</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Payment Date</TableCell>
                                    <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Status</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0' }}>
                                {Object.entries(electricianAggregatedInstaller)?.map(([billNo, electricians], index1) => {
                                    if (billNo == 13) {
                                        console.log("dddddddss", billNo, electricians)
                                    }
                                    
                                    let totalPayment = 0;
                                    let installerName;
                                    let InstallerPay;
                                    let invoiceNo;
                                    let InstallerpayTotal;
                                    let date;
                                    let givenPayment = 0;

                                    const latestDate = electricians
                                        ?.map(e => new Date(e?.paymentDate))
                                        .filter(date => !isNaN(date)) // remove invalid dates
                                        .sort((a, b) => b - a)[0]; // descending order

                                    const formattedLatestDate = latestDate?.toLocaleDateString();

                                    electricians?.map((v, index2) => {
                                        installerName = assignInstaller?.find(u => u._id === v.assignId)?.Electrician;

                                        InstallerPay = allInstallerpayment?.filter(d => d?.userId == installerName)
                                        // const endDateForEdit = `${periodData.formattedStartDate} - ${periodData.periodKey.split('-')[3]}`
                                        // const InstallerDate = InstallerPay?.find(d => d.monthPeriod == endDateForEdit)
                                        InstallerpayTotal = InstallerPay?.fileDetails?.reduce((total, item) => total + (item.PaymentTotal || 0), 0) || 0
                                        invoiceNo = `Electrician/${assignInstaller?.find(a => a.Electrician == installerName)?.electricianData?.[0]?.name}/${new Date(v?.submitDate)?.toLocaleDateString()}/${billNo}`;
                                        totalPayment = totalPayment + parseFloat(v.TotalAmount)
                                        date = new Date(v?.submitDate)?.toLocaleDateString()

                                        console.log("444444", v, installerName, InstallerPay, index2 + 1, invoiceNo, totalPayment, InstallerpayTotal)

                                        if (v?.paymentAmount) {
                                            givenPayment = givenPayment + parseFloat(v?.paymentAmount + v?.tds);
                                        }
                                    });




                                    return (

                                        <TableRow key={`${index1}`}>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {index1 + 1}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {invoiceNo}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {date}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {assignInstaller?.find(a => a.Electrician == installerName)?.electricianData?.[0]?.name}
                                                {/* {assignInstaller?.find(a => a.Electrician == v.installerName)?.electricianData?.[0]?.name === "kishan patel" ? console.log("kishan patel	kishan pate", periodData) : ''} */}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{totalPayment % 1 === 0 ? totalPayment.toString() : totalPayment.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {givenPayment}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {
                                                    formattedLatestDate
                                                }
                                            </TableCell>

                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {givenPayment >= totalPayment ? 'Complete' : 'Pending'}
                                            </TableCell>
                                            <TableCell>
                                                <IconButton aria-label="edit" onClick={() => handleEdit({ installerName, amount: totalPayment, invoiceNo, billNo }, billNo, electricians, 'electrician')}>
                                                    <EditIcon />
                                                </IconButton>
                                            </TableCell>

                                        </TableRow>
                                    )

                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>

            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        No Results Found.
                    </Typography>
                </Box>
            )}


            
        </Box>
    )
}

export default InstallerPayment
